import React, { createContext, useContext, useState, ReactNode } from 'react';
import enMessages from '../translations/en.json';
import fiMessages from '../translations/fi.json';

type Language = 'en' | 'fi';

interface LanguageContextType {
	language: Language;
	setLanguage: (lang: Language) => void;
	messages: Record<string, string>;
}

const messages = {
	en: enMessages,
	fi: fiMessages,
};

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
	const [language, setLanguage] = useState<Language>('fi');

	const value = {
		language,
		setLanguage,
		messages: messages[language],
	};

	return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
	const context = useContext(LanguageContext);
	if (context === undefined) {
		throw new Error('useLanguage must be used within a LanguageProvider');
	}
	return context;
};
